<template>
  <div :class="{ 'd-flex': horizontal }">
    <div
      v-for="item in options"
      :key="item.id"
      :class="{ 'mt-1 mr-4': horizontal, 'mt-3': !horizontal }"
    >
      <b-form-radio
        :checked="checked"
        class="custom-radio"
        :disabled="isReadOnly"
        size="lg"
        :value="item.id"
        @input="onSelect"
      >
        {{ item.name }}
      </b-form-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RubricPreviewQuestionRadio',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    horizontal: {
      type: Boolean,
      default: () => false,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    checked() {
      return this.value?.id;
    },
  },
  methods: {
    onSelect(id) {
      const value = this.options.find((x) => x.id === id);
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-radio
  ::v-deep
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: rgba(45, 183, 130, 0.5);
}
</style>
